(function () {
  'use strict';

  var config = window.VinotecaFiambreGift;
  if (!config || !config.enabled) return;

  var now = Date.now();
  var start = Date.parse(config.start);
  var end = Date.parse(config.end);
  var isWithinDates = Number.isFinite(start) && Number.isFinite(end) && now >= start && now < end;
  if (!config.testMode && !isWithinDates) return;

  var giftVariantId = Number(config.giftVariantId);
  var qualifyingHandles = {
    'fiambre-blanco': true,
    'fiambre-colorado': true,
    'fiambre-thai': true
  };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch && window.fetch.bind(window);
  var syncing = false;
  var timer = null;

  function requestJson(path, options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', root + path, true);
      xhr.setRequestHeader('Accept', 'application/json');
      if (options.headers) {
        Object.keys(options.headers).forEach(function (name) {
          xhr.setRequestHeader(name, options.headers[name]);
        });
      }
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          reject(new Error('Cart request failed: ' + xhr.status + ' ' + xhr.responseText));
          return;
        }
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = function () {
        reject(new Error('Cart request failed: network error'));
      };
      xhr.send(options.body || null);
    });
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(String(url || ''));
  }

  function queueSync() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncGift, 180);
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'fiambre-gift' } }));
    window.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'fiambre-gift' } }));
    window.setTimeout(function () { window.location.reload(); }, 180);
  }

  function isPromoItem(item) {
    return (
      Number(item.variant_id) === giftVariantId &&
      item.properties &&
      String(item.properties._fiambre_promo) === 'true'
    );
  }

  function removePromoLines(attempt) {
    if (attempt > 20) return Promise.reject(new Error('Too many promotional cart lines'));

    return requestJson('cart.js?fiambre_cleanup=' + Date.now()).then(function (cart) {
      var promoLine = null;
      cart.items.some(function (item) {
        if (isPromoItem(item)) {
          promoLine = item;
          return true;
        }
        return false;
      });

      if (!promoLine) return;

      return requestJson('cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: promoLine.key, quantity: 0 })
      }).then(function () {
        return removePromoLines(attempt + 1);
      });
    });
  }

  function syncGift() {
    if (syncing) return;
    syncing = true;

    requestJson('cart.js?fiambre=' + Date.now())
      .then(function (cart) {
        var qualifyingQuantity = 0;
        var promoQuantity = 0;

        cart.items.forEach(function (item) {
          if (qualifyingHandles[item.handle]) qualifyingQuantity += item.quantity;
          if (isPromoItem(item)) promoQuantity += item.quantity;
        });

        var targetGiftQuantity = Math.floor(qualifyingQuantity / 3);
        if (promoQuantity === targetGiftQuantity) return false;

        return removePromoLines(0).then(function () {
          if (targetGiftQuantity < 1) return true;

          return requestJson('cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: giftVariantId,
                quantity: targetGiftQuantity,
                properties: { '_fiambre_promo': 'true' }
              }]
            })
          }).then(function () { return true; });
        });
      })
      .then(function (changed) {
        if (changed) refreshCartUi();
      })
      .catch(function (error) {
        console.warn('[Promoción Fiambre] No se pudo sincronizar el regalo.', error);
      })
      .finally(function () {
        syncing = false;
      });
  }

  if (nativeFetch) {
    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      return nativeFetch.apply(null, args).then(function (response) {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
        if (isCartMutation(url)) queueSync();
        return response;
      });
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._fiambreGiftUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this._fiambreGiftUrl)) {
      this.addEventListener('loadend', queueSync, { once: true });
    }
    return nativeSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  } else {
    queueSync();
  }
})();
